var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./BahnnostalgieMoviesList.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-c46b5d5a\",\"hasScoped\":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./BahnnostalgieMoviesList.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/BahnnostalgieMoviesList.vue
// module id = 62
// module chunks = 0